import React from 'react';
import { Layout } from '../components/Layout';
import { Server, Cloud, Shield, Cpu, Globe, Lock, Check } from 'lucide-react';
import Tuotteet from '../components/Tuotteet.tsx';

import { motion } from 'framer-motion';

export const Services: React.FC = () => {
  return (
    <Layout>
      <div className="pt-20">
        {/* Features Grid */}
        <section id="services" className="py-24 bg-slate-50">
          <div className="container mx-auto px-6">
            <div className="text-center max-w-3xl mx-auto mb-16">
              <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">Etsitkö täydellistä sijoituspaikkaa palvelimillesi ja tietoliikennelaitteillesi?</h2>
              <p className="text-slate-600 text-lg">Helsinki DC tarjoaa monipuoliset ja nopeat yhteydet kaikkialle maailmaan, mukaan lukien Venäjälle, Aasiaan ja Baltiaan. Vikasietoinen runkoverkkomme sisältää useita itsenäisiä reittejä, varmistaen katkeamattoman ja nopean tiedonsiirron. Tarjoamme myös tehokkaan DDoS-suojan, joka suodattaa haitallisen liikenteen automaattisesti varmistaen palveluiden katkeamattoman toiminnan.</p>
            </div>

<div className="grid md:grid-cols-3 gap-8">
            {[
              {
                icon: <Server className="w-8 h-8 text-blue-600" />,
                title: "Colocation",
                desc: "Tuo omat palvelimet palvelinsaliin, joka on toimintavarma ja energiatehokas. Helsinki DC täyttää turvallisuus-, jäähdytys-, energiatehokkuus- ja sähköstandardit."
              },
              {
                icon: <Cloud className="w-8 h-8 text-emerald-600" />,
                title: "Cloud",
                desc: "Joustavat pilvipalvelut laskenta- ja tallennusoptimoidut pilvipalvelimet. KVM, VMware ja OpenStack."
              },
              {
                icon: <Shield className="w-8 h-8 text-indigo-600" />,
                title: "Private Cloud",
                desc: "Datasi pysyy Suomessa. GDPR-vaatimukset täyttävä fyysinen ja digitaalinen ratkaisu."
              },
              {
                icon: <Cpu className="w-8 h-8 text-orange-600" />,
                title: "Baremetal",
                desc: "Jätä raudan hankinta ja ylläpito huoleksemme. Tehokkaat dedikoidut palvelimet täydellä pääkäyttäjän oikeuksilla. Ihanteellinen intensiivisille työkuormille ja mukautetulle virtualisoinnille. Nopeat 10 Gbit/s yhteydet ja NVMe levyjärjestelmät."
              },
              {
                icon: <Globe className="w-8 h-8 text-cyan-600" />,
                title: "Verkkoyhteydet",
                desc: "Verkkoyhteydet saatavilla kaikilta operaattoreilta, DWDM-yhteydet FICIX-solmupisteisiin ja DDoS-suojattu verkkoyhteys jopa 100 Gbit/s nopeudella."
              },
              {
                icon: <Lock className="w-8 h-8 text-red-600" />,
                title: "Kyberturvallisuus",
                desc: "Edistynyt uhkien torjunta, palvelunestohyökkäysten torjunta ja 24/7-tietoturvan valvonta infrastruktuurisi turvallisuuden takaamiseksi."
              }
            ].map((feature, idx) => (
              <motion.div
                key={idx}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: idx * 0.1 }}
                className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-md transition-shadow border border-slate-100"
              >
                <div className="bg-slate-50 w-16 h-16 rounded-xl flex items-center justify-center mb-6">
                  {feature.icon}
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-3">{feature.title}</h3>
                <p className="text-slate-600 leading-relaxed">{feature.desc}</p>
              </motion.div>
            ))}
          </div>
         </div>
        </section>

      <Tuotteet/>

      </div>
    </Layout>
  );
};
